<select #comboBox
  [(ngModel)]="selectedStudioId" [disabled]="disabled" [hidden]="!visible"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [class.combo-box-required]="required"
  [style.width.px]="width" [style.width]="undefined !== width ? width : '100%'"
  [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.studioMasterList">
    <option value="{{item.StudioId}}">{{item.StudioIdName}}</option>
  </ng-template>
</select>
